import { combineReducers } from 'redux'
import misc from './misc'
import reminder from './reminder'

export default combineReducers({
  misc,
  reminder,
})
